import React from 'react';
import { Slider, Tooltip } from 'antd';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './index.scss';

function formatter(value) {
  return parseFloat(value).toFixed(2);
}

function RangeSlider({
  marks = {},
  value = 0,
  readOnly = false,
  min = 0,
  max = 1,
  handler = () => {},
  description = '',
  behaviour = '',
  unique_id,
  ...props
}) {
  const handleChange = (value) => {
    value = value.toFixed(2);
    handler(value, unique_id);
  };

  const renderToolTip = () => (
    <div className={styles.tooltip}>
      <div>
        <p className={styles.head}>Description:</p>
        <p className={styles.value}>{description}</p>
      </div>
      <div>
        <p className={styles.head}>Behaviour:</p>
        <p className={styles.value}>{behaviour}</p>
      </div>
      <div>
        <p className={styles.head}>Recomended Score Setting:</p>
        <p className={styles.value}>{Object.keys(marks)[0]}</p>
      </div>
    </div>
  );

  return (
    <div className={styles.rangeSlider}>
      <span className={styles.items} style={{ width: '40px' }}>
        {min?.toFixed(2)}
      </span>
      <Slider
        id={`config__param__slider__${unique_id}`}
        value={formatter(value)}
        disabled={readOnly}
        min={min}
        max={max}
        className={`${styles.slider} custom__range-slide`}
        onChange={handleChange}
        tooltipVisible={false}
        {...props}
      />
      <span className={styles.items} style={{ width: '40px' }}>
        {max?.toFixed(2)}
      </span>
      <div className={styles.items}>
        <input
          id={`config__param__slider__${unique_id}`}
          className={'range_input'}
          type="number"
          value={'' + value}
          disabled={true}
          onChange={(e) => {
            let value = e.target.value;
            if (value > max) value = max;
            if (value < min) value = min;
            const t = value.toString();
            value =
              t.indexOf('.') >= 0
                ? t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 3)
                : t;

            handler(value, unique_id);
            hideIfValueEqualsRecomended(value);
          }}
        />
      </div>
      <div className={styles.items}>
        <Tooltip
          placement="right"
          overlayClassName={styles.information}
          title={renderToolTip()}>
          <div className={styles.recomended}>
            <FontAwesomeIcon
              icon={faInfo}
              color={'#B8BEC5'}
              style={{ fontSize: '12px' }}
            />
          </div>
        </Tooltip>
      </div>
    </div>
  );
}

function areEqual(prevProps, nextProps) {
  /*
  return true if passing nextProps to render would return
  the same result as passing prevProps to render,
  otherwise return false
  */

  return prevProps.value === nextProps.value;
}

export default RangeSlider;
